class OrderBookLine {
    constructor(data, pathFromRoot) {
        this.setUp(data, pathFromRoot)
    }

    static create(data, pathFromRoot = null) {
        if (pathFromRoot == null) 
            pathFromRoot = []
        if (data == null)
            return null
        if (data instanceof OrderBookLine)
            return data
        for (let obj of pathFromRoot)
            if (obj instanceof OrderBookLine && obj.id == data.id)
                return obj
        return new OrderBookLine(data, pathFromRoot)
    }

    setUp(data, pathFromRoot) {
        pathFromRoot.push(this)
        this.quantity = data.quantity
        this.quote = data.quote
        this.price = data.price
        pathFromRoot.pop()
    }
}

export class OrderBook {
    static create(data, pathFromRoot = null) {
        if (pathFromRoot == null) 
            pathFromRoot = []
        if (data == null)
            return null
        if (data instanceof OrderBook)
            return data
        for (let obj of pathFromRoot)
            if (obj instanceof OrderBook && obj.id == data.id)
                return obj
        return new OrderBook(data, pathFromRoot)
    }

    constructor(data, pathFromRoot) {
        this.setUp(data, pathFromRoot)
    }

    setUp(data, pathFromRoot) {
        pathFromRoot.push(this)
        this.side = data.side
        this.market = data.market
        this.lines = data.lines.map(lineData => OrderBookLine.create(lineData, pathFromRoot))
        this.bestPrice = data.bestPrice
        this.totalQuantity = data.totalQuantity
        this.TotalQuote = data.totalQuote
        this.worstPrice = data.worstPrice
        pathFromRoot.pop()
    }

    quoteByQuantity(quantity) {
        let i = 0
        let total_quote = 0
        while (quantity > 0) {
            var line;
            if (i < this.lines.length)
                line = this.lines[i]
            else
                line = OrderBookLine.create({
                    quantity: 1000000000000,
                    quote: quantity * this.worstPrice,
                    price: this.worstPrice
                })
            let done_quantity = Math.min(line.quantity, quantity)
            let done_quote = done_quantity * line.price
            quantity -= done_quantity
            total_quote += done_quote
            i += 1
        }
        return total_quote
    }


    quantityByQuote(quote) {
        let i = 0
        let total_quantity = 0
        while (quote > 0) {
            var line;
            if (i < this.lines.length)
                line = this.lines[i]
            else
                line = OrderBookLine.create({
                    quantity: quote / this.worstPrice,
                    quote: 100000000000000,
                    price: this.worstPrice
                })
            let done_quote = Math.min(line.quote, quote)
            let done_quantity = done_quote / line.price
            quote -= done_quote
            total_quantity += done_quantity
            i += 1
        }
        return total_quantity
    }
}
